import * as React from 'react';

const IconArrowChevronLeftArrowRight = ({ size = 24, color = '#313A44' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.11387 17.7961C8.79833 18.1369 8.79833 18.6631 9.11387 19.0039L9.38394 19.2956C9.73575 19.6755 10.3366 19.6755 10.6884 19.2956L16.8844 12.6039C17.1999 12.2631 17.1999 11.7368 16.8844 11.396L10.6884 4.70441C10.3366 4.32445 9.73578 4.32445 9.38397 4.70441L9.11391 4.99607C8.79836 5.33686 8.79836 5.86312 9.11391 6.20391L14.4806 11.9999L9.11387 17.7961Z"
        fill={color}
      />
    </svg>
  );
};

export default React.memo(IconArrowChevronLeftArrowRight);
